import { apiClient } from '@/lib/api-client';
import { clearClientSession } from '@/lib/clear-client-session';
import { toast } from '@nautilusbio/nb-design-system/Toaster';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

/**
 * Custom hook for handling user logout.
 * Includes API call, full client-side session clear, and navigation.
 */
export const useLogout = () => {
  const navigate = useNavigate();

  return useMutation<void, Error, void>({
    mutationFn: async () => {
      // POST to server logout endpoint first (invalidates the session cookie)
      await apiClient.post('/auth/logout', undefined, { skipDefaultHeaders: true });

      // Clear all client-side state (cache, Zustand, sessionStorage) in one place
      clearClientSession();

      // Hard navigation ensures a fresh app boot and avoids rehydration/race
      // conditions on quick re-login. Replace so back button doesn't return
      // to an authenticated view.
      try {
        window.location.replace('/login');
      } catch {
        await navigate({ to: '/login', viewTransition: true });
      }
    },
    onError: error => {
      console.error('Logout failed:', error);
      toast.error('Failed to logout. Please try again.');
    },
  });
};
